import type {
  OnboardingPldMoralRequest,
  OnboardingPldPhysicalRequest,
  PldStepData,
} from './models';

import { saveOnboardingStep } from './onboarding-step';

type PldStepRequest = OnboardingPldPhysicalRequest | OnboardingPldMoralRequest;

const saveOnboardingPldStep = saveOnboardingStep<PldStepData, PldStepRequest>(
  'No se pudo guardar la información',
);

export const savePld = (body: OnboardingPldPhysicalRequest) =>
  saveOnboardingPldStep('put', '/onboarding/pld', body);

export const createPldMoral = (body: OnboardingPldMoralRequest) =>
  saveOnboardingPldStep('post', '/onboarding/pld/moral', body);

export const updatePldMoral = (body: OnboardingPldMoralRequest) =>
  saveOnboardingPldStep('put', '/onboarding/pld/moral', body);
